import React from "react";
import ResponseRenderer from "./renderers/ResponseRenderer";

/**
 * AssistantMessage - Displays a message from the AI assistant
 * Uses ResponseRenderer to display structured data in a user-friendly format
 * @param {Object} message - The assistant message object
 * @returns {JSX.Element}
 */
const AssistantMessage = ({ message }) => {
    return (
        <div className="flex justify-start w-full">
            <div className="max-w-[90%] sm:max-w-[90%] bg-white text-gray-800 rounded-2xl rounded-bl-sm px-4 py-3 shadow-sm border border-gray-100">
                {/* Use ResponseRenderer for structured display */}
                <ResponseRenderer message={message} />

                {/* Timestamp */}
                <span className="text-[10px] opacity-60 mt-2 block text-gray-500">
                    {new Date(message.timestamp).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}
                </span>
            </div>
        </div>
    );
};

export default AssistantMessage;
